import { Editor, Range, Transforms } from 'slate';

import { setDefaults } from '../../../../../slatePlugins/common/utils/setDefaults';
import { unwrapNodes } from '../../../../../slatePlugins/transforms/unwrapNodes';
import { isBlockActive } from '../../../helpers';
import {
  unwrapBlockAtSelection,
  wrapBlockAtSelection,
} from '../../../helpers/toggleBlockAtSelection';
import { DEFAULT_HIGHLIGHT } from '../defaults';
import { HighlightOptions } from '../types';

export const wrapHighlight = (
  editor: Editor,
  colorKey: string,
  options?: {
    at?: Location | Range;
  } & HighlightOptions
) => wrapBlockAtSelection(editor, options.highlightElement.type, { highlightKey: colorKey });

export const unwrapHighlight = (editor, options) =>
  unwrapBlockAtSelection(editor, options.highlightElement.type);

export const upsertHighlightAtSelection = (
  editor: any,
  colorKey: string,
  options?: HighlightOptions
) => {
  if (!editor.selection) return;

  const { highlightElement } = setDefaults(options, DEFAULT_HIGHLIGHT);
  if (isBlockActive(editor, highlightElement.type)) {
    unwrapHighlight(editor, options);
    wrapHighlight(editor, colorKey, options);
  } else {
    unwrapNodes(editor, { match: { type: highlightElement.type } as any, at: editor.selection });
    wrapHighlight(editor, colorKey, options);
    Transforms.collapse(editor, { edge: 'end' });
  }
};
